<div
  class="step-container columns is-desktop"
  [class.step-container--advisor-contact]="currentStep === STEPS.ADVISOR_CONTACT"
  [class.step-container--premium-acceptance]="currentStep === STEPS.PREMIUM_ACCEPTANCE"
>
  @if (currentStep !== STEPS.ADVISOR_CONTACT && currentStep !== STEPS.PREMIUM_ACCEPTANCE) {
    <app-aside-bar [isLogged]="isLogged" [isBusiness]="isBusiness"></app-aside-bar>
  } @else {
    <app-menu-bar-mobile></app-menu-bar-mobile>
  }
  <div class="starter-board" [class.container-user-not-logged]="!isLogged">
    @if (!isBusiness) {
      @if (currentStep === STEPS.TAX_YEAR_SELECT) {
        <h1 class="title_42">
          <span class="title__stage">{{ "COMMON.HI" | translate }}</span>
          <span class="title__stage">{{ "START.LETS_START" | translate }}</span>
        </h1>
        @if (dataSelects) {
          <div class="big-label-container">
            <div class="ep_new_tiles_wrap top">
              @for (statementYear of dataSelects.statementYears; track statementYear; let key = $index) {
                <div class="ep_new_single_tile_wrap">
                  <div
                    class="ep_new_single_tile center"
                    (click)="setStatementYear(statementYear)"
                    [class.active]="statement.year === statementYear.id || statementYear.active"
                  >
                    <div class="ep_desc_wrap slg">
                      <div class="icon_tile_wrap slg">
                        <img src="../../../assets/svg/years_icons/year_vs{{ key }}.svg" class="icon_tile" />
                      </div>
                      <h3 class="title_tile_lg">{{ statementYear.year }}</h3>
                    </div>
                  </div>
                  @if (showEndingYear(key) > 0) {
                    <div class="tooltip_w_desc_wrap">
                      <div class="desc">
                        {{ "START.LAST_YEAR_INFO_PART1" | translate }} {{ showEndingYear(key) }}
                        {{ "START.LAST_YEAR_INFO_PART2" | translate }}
                      </div>
                      <div class="tooltip_wrap">
                        <app-more-info-tooltip
                          [alignLeft]="true"
                          [isSmall]="true"
                          [isSmallIcon]="true"
                          [showText]="false"
                          [message]="'START.LAST_YEAR_INFO_TOOLTIP'"
                        >
                        </app-more-info-tooltip>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
      }
      @if (dataSelects?.preliminaryData) {
        @for (item of dataSelects.preliminaryData; track $index) {
          @if (currentStep === STEPS.INCOME_COST_SELECT && currentIncomeCostSubStepIndex === $index) {
            <app-question-with-options
              [question]="getIncomeCostsQuestion(item.type)"
              [optionsTitle]="item.title"
              [options]="item.data"
              [selectedOptions]="getSelectedOptionsForEntry(item.type, item.data[0]?.supported ?? false)"
              (selectedOptionsChange)="
                onPreliminaryDataSelectionChange($event, item.type, item.data[0]?.supported ?? false)
              "
            ></app-question-with-options>
          }
        }
      }
      @if (currentStep === STEPS.ADVISOR_CONTACT && showAdvisorContactStep) {
        <app-advisor-contact-step
          (submitInquiry)="onSubmitAdvisorInquiry($event)"
          [user]="user"
          [isEmailSending]="isEmailSending"
        ></app-advisor-contact-step>
      }
      @if (currentStep === STEPS.PREMIUM_ACCEPTANCE && showPremiumAcceptanceStep) {
        <app-premium-acceptance></app-premium-acceptance>
      }
      @if (currentStep === STEPS.APPLICANT_INFO) {
        <div class="step_wrapper">
          <div class="step_cont">
            <h1 class="title_42">
              <span class="title__stage">{{ "EMPLOYER.NOT_LOGEDIN_FORM_TITLE" | translate }}</span>
            </h1>
            <div class="form_wrap">
              <div class="form_col">
                <app-form-input
                  [errors]=""
                  [label]="'EMPLOYER.NOT_LOGEDIN_FORM_FIRST_NAME_LABEL'"
                  [placeholder]="'EMPLOYER.NOT_LOGEDIN_FORM_FIRST_NAME'"
                  [(model)]="personalInfoOnLogin.firstname"
                  (blur)="onBlurPersonalInfoOnLogin()"
                  [autocomplete]="'given-name'"
                  [name]="'firstName'"
                >
                </app-form-input>
              </div>
              @if (isLogged) {
                <div class="form_col">
                  <app-form-input
                    [errors]=""
                    [label]="'EMPLOYER.NOT_LOGEDIN_FORM_LAST_NAME_LABEL'"
                    [placeholder]="'EMPLOYER.NOT_LOGEDIN_FORM_LAST_NAME'"
                    [(model)]="personalInfoOnLogin.lastname"
                    (blur)="onBlurPersonalInfoOnLogin()"
                    [autocomplete]="'family-name'"
                    [name]="'lastName'"
                  >
                  </app-form-input>
                </div>
              }
              <div class="form_col full">
                @if (!isLogged) {
                  <app-form-input
                    [errors]=""
                    [label]="'EMPLOYER.NOT_LOGEDIN_FORM_EMAIL_LABEL'"
                    [placeholder]="'EMPLOYER.NOT_LOGEDIN_FORM_EMAIL'"
                    [(model)]="personalInfoOnLogin.emailAddress"
                    (blur)="onBlurPersonalInfoOnLogin()"
                    [inputType]="'email'"
                    [autocomplete]="'email'"
                    [name]="'email'"
                  >
                  </app-form-input>
                }
              </div>
            </div>
          </div>
        </div>
      }
      @if (currentStep === STEPS.QUESTION_ABOUT_CAN_BE_FILLED && isLogged) {
        <div class="step_wrapper">
          <div class="step_cont">
            <div class="title_w_tooltip">
              <h1 class="title_42 mb-0_625">
                {{ "EMPLOYER.STEP_0_TITLE_1" | translate }}{{ personalInfoOnLogin.firstname }} <br />{{
                  "EMPLOYER.STEP_0_TITLE_2" | translate
                }}
                <span class="tooltip_wrap">
                  <app-more-info-tooltip
                    [titleTooltip]="'EMPLOYER.STEP_0_TOOLTIP_TITLE'"
                    [message]="'EMPLOYER.STEP_0_TOOLTIP_DESC'"
                    [isInnerHTML]="true"
                  >
                  </app-more-info-tooltip>
                </span>
              </h1>
            </div>
            <h4 class="desc_20 mb-2">
              <span class="title__stage">{{ "EMPLOYER.STEP_0_DESCRIPTION" | translate }}</span>
            </h4>
            <app-button-radio-two
              [selectedOption]="statement.canBeFilled"
              (clickEmitter)="setCanBeFilled($event)"
            ></app-button-radio-two>
          </div>
        </div>
      }
    }
    @if (isBusiness) {
      <div class="starter_business_wrap">
        <h1 class="title">
          <span class="title__stage">
            <span class="welcome">{{ "COMMON.HI" | translate }}</span> {{ user?.firstName }},
            <span>{{ "START.LETS_START_WITH" | translate }}</span>
          </span>
          <span class="title__stage">{{ "START.BUSINESS_TAXCARD" | translate }}</span>
        </h1>
        <div class="description">{{ "START.BUSINESS_DESCRIPTION" | translate }}</div>
        <div class="starter-board__modes">
          <div class="form-content mx-0">
            <div class="starter-board__mode hide-ocr-ios">
              <div class="starter-board__mode-btn">
                <label class="file-upload-button">
                  <input
                    type="file"
                    accept="application/pdf,image/*"
                    [disabled]="uploadingScan"
                    (change)="onScanUpload($event.target)"
                  />
                  @if (!uploadingScan) {
                    <a class="btn btn--primary btn--block"> {{ "START.UPLOAD_TAXCARDS" | translate }} </a>
                  }
                  @if (uploadingScan) {
                    <button class="btn btn--primary btn--block" disabled>
                      {{ "START.UPLOAD_TAXCARDS" | translate }}
                    </button>
                  }
                </label>
              </div>
              <div class="starter-board__mode-description is-small">
                {{ "START.UPLOAD_TAXCARD_DESCRIPTION" | translate }}
              </div>
            </div>
            <div class="starter-board__mode hide-ocr-ios">
              <div class="starter-board__mode-btn">
                <label class="file-upload-button">
                  <input
                    type="file"
                    accept="application/json/*"
                    [disabled]="uploadingScan"
                    (change)="onScanUpload($event.target, true, true)"
                  />
                  @if (!uploadingScan) {
                    <a class="btn btn--primary btn--block"> {{ "START.UPLOAD_TAXCARDS_JSON" | translate }} </a>
                  }
                  @if (uploadingScan) {
                    <button class="btn btn--primary btn--block" disabled>
                      {{ "START.UPLOAD_TAXCARDS_JSON" | translate }}
                    </button>
                  }
                </label>
              </div>
              <div class="starter-board__mode-description is-small">
                {{ "START.UPLOAD_TAXCARD_DESCRIPTION" | translate }}
              </div>
            </div>
            <div class="starter-board__mode">
              <div class="starter-board__mode-btn">
                <button
                  class="btn btn--primary btn--block"
                  [disabled]="creatingBatch"
                  (click)="createBatchManually()"
                  [attr.data-cy]="'btnCreateStatementBatchManually'"
                >
                  {{ "START.CREATE_EMPTY_BATCH" | translate }}
                </button>
              </div>
              <div class="starter-board__mode-description is-small">
                {{ "START.CREATE_EMPTY_BATCH_DESCRIPTION" | translate }}
              </div>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
  @if (!isBusiness) {
    <app-tools-bar
      [statement]="statement"
      [buttons]="buttons"
      [isLogged]="isLogged"
      [viewMode]="
        currentStep !== STEPS.ADVISOR_CONTACT && currentStep !== STEPS.PREMIUM_ACCEPTANCE
          ? ToolsBarViewMode.STATEMENT
          : ToolsBarViewMode.SINGULAR
      "
    ></app-tools-bar>
  }
</div>
